import React from "react";
import Header from "./header";
import Mockheader from "./mock_header";
import "./cssfile/hoc.css";

export default function HOC(Component) {
  return function NewComponent(props) {
    return (
      <div className="app-shell">

        {/* TOP HEADER */}
        <div className="app-top-header">
          <Header />
        </div>

        {/* BELOW HEADER */}
        <div className="app-content">

          <div className="app-left-sidebar">
            <Mockheader {...props} />
          </div>

          <div className="app-page-content">
            <Component {...props} />
          </div>

        </div>

      </div>
    );
  };
}